import { gql } from '@apollo/client';

const CLOUDFRONT_QUERY_SIGNATURE_QUERY = gql`
  query cloudFrontQuerySignature($filter: CloudFrontQuerySignatureFilter!) {
    cloudFrontQuerySignature(filter: $filter) {
      isSuccess
      message
      cloudFrontQuerySignature
    }
  }
`;

export default CLOUDFRONT_QUERY_SIGNATURE_QUERY;
